/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ObjectObjectConfiguration as __Configuration } from '../object-object-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class AddressService extends __BaseService {
  static readonly getAddressListPath = '/address';
  static readonly storeAddressPath = '/address';
  static readonly getAddressPath = '/address/{id}';
  static readonly updateAddressPath = '/address/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Get list of address.
   * @param params The `AddressService.GetAddressListParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `lang`: Language short code.
   */
  getAddressListResponse(params: AddressService.GetAddressListParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    if (params.lang != null) __params = __params.set('lang', params.lang.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/address`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get list of address.
   * @param params The `AddressService.GetAddressListParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `lang`: Language short code.
   */
  getAddressList(params: AddressService.GetAddressListParams): __Observable<null> {
    return this.getAddressListResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Store the addresses.
   * @param params The `AddressService.StoreAddressParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Store address.
   */
  storeAddressResponse(params: AddressService.StoreAddressParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/address`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Store the addresses.
   * @param params The `AddressService.StoreAddressParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Store address.
   */
  storeAddress(params: AddressService.StoreAddressParams): __Observable<null> {
    return this.storeAddressResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Set as initial view.
   * @param params The `AddressService.GetAddressParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `lang`: Language short code.
   */
  getAddressResponse(params: AddressService.GetAddressParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    if (params.lang != null) __params = __params.set('lang', params.lang.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/address/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Set as initial view.
   * @param params The `AddressService.GetAddressParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `lang`: Language short code.
   */
  getAddress(params: AddressService.GetAddressParams): __Observable<null> {
    return this.getAddressResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Update addresses.
   * @param params The `AddressService.UpdateAddressParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update Addresses
   */
  updateAddressResponse(params: AddressService.UpdateAddressParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/address/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Update addresses.
   * @param params The `AddressService.UpdateAddressParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update Addresses
   */
  updateAddress(params: AddressService.UpdateAddressParams): __Observable<null> {
    return this.updateAddressResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module AddressService {

  /**
   * Parameters for getAddressList
   */
  export interface GetAddressListParams {
    Authorization: string;

    /**
     * Language short code.
     */
    lang?: string;
  }

  /**
   * Parameters for storeAddress
   */
  export interface StoreAddressParams {
    Authorization: string;

    /**
     * Store address.
     */
    body?: {};
  }

  /**
   * Parameters for getAddress
   */
  export interface GetAddressParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;

    /**
     * Language short code.
     */
    lang?: string;
  }

  /**
   * Parameters for updateAddress
   */
  export interface UpdateAddressParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;

    /**
     * Update Addresses
     */
    body?: {};
  }
}

export { AddressService }
